import { useState, useEffect } from "react";
import { getDocs } from "firebase/firestore";
import { firestore, collection, query, where } from "../firebase";

const DEFAULT_AVATAR_URL = "";

/**
 * Loads the current user's profile (avatar) from Firestore.
 * Returns [profilePicture, setProfilePicture]. Resets to default when userId is null.
 */
export function useUserProfile(userId) {
  const [profilePicture, setProfilePicture] = useState(DEFAULT_AVATAR_URL);

  useEffect(() => {
    if (!userId) {
      setProfilePicture(DEFAULT_AVATAR_URL);
      return;
    }

    let cancelled = false;

    const load = async () => {
      try {
        const q = query(
          collection(firestore, "users"),
          where("uid", "==", userId)
        );
        const snap = await getDocs(q);
        const avatar = snap.docs[0]?.data()?.avatar;
        if (!cancelled && avatar) setProfilePicture(avatar);
      } catch (err) {
        if (!cancelled) console.error("Error fetching user data:", err);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [userId]);

  return [profilePicture, setProfilePicture];
}

export { DEFAULT_AVATAR_URL };
